import React from 'react';
import { defaultTemplate } from 'core/hoc';

const BasicCheckboxTemplate = function({
	customLabel,
	id,
	label,
	checked,
	className = 'input input--check',
	onChange,
	t,
	disabled,
}) {
	return (
		<React.Fragment>
			<input
				id={id}
				data-cy={`${id}-checkbox`}
				checked={checked}
				onChange={onChange}
				disabled={disabled}
				type="checkbox"
				className={className}
			/>
			<label htmlFor={id} data-cy={`${id}-label`}>
				{customLabel ? t(customLabel) : t(label)}
			</label>
		</React.Fragment>
	);
};

export default defaultTemplate(BasicCheckboxTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/forms/BaasicCheckboxTemplate.js